import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import { Trans, useTranslation } from 'react-i18next';
import { Icon } from '@pwc/pwc-deals-ui';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getErrorModalState,
  hideModalError,
} from '../../redux/errors/errorsSlice';
import './ModalError.scss';
import { UNABLE_TO_ADD_OBJECT } from './constants';
import SupportTicketLink from '../SupportTicketLink';

const getModalErrorTitle = (type, t) => {
  switch (type) {
    case Constants.ModalErrorType.UNABLE_TO_SAVE_CHANGE: {
      return (
        <span className="title-with-icon">
          <Icon name="alert" className="fill icon-yellow" width="24" />
          <span>{t('unableToSave')}</span>
        </span>
      );
    }
    case Constants.ModalErrorType.UNABLE_TO_SAVE_SORT_ORDER_STALE_DATA:
    case Constants.ModalErrorType.UNABLE_TO_SAVE_SORT_ORDER: {
      return (
        <span className="title-with-icon">
          <Icon name="alert" className="fill icon-yellow" width="24" />
          <span>{t('unableToSaveOrder')}</span>
        </span>
      );
    }
    case UNABLE_TO_ADD_OBJECT: {
      return (
        <span
          className="title-with-icon"
          aria-label="unable to add object title"
        >
          <Icon name="alert" className="fill icon-yellow" width="24" />
          <span>{t('modal.unableToAddObject')}</span>
        </span>
      );
    }
    default: {
      return '';
    }
  }
};

const getModalErrorBody = (type, t) => {
  switch (type) {
    case Constants.ModalErrorType.UNABLE_TO_SAVE_CHANGE: {
      return (
        <Trans i18nKey="modal.systemErrorSaving">
          Due to a system error, we are currently unable to save your changes.
          Please try again later. If the issue continues, <SupportTicketLink />.
        </Trans>
      );
    }
    case Constants.ModalErrorType.UNABLE_TO_SAVE_SORT_ORDER: {
      return (
        <Trans i18nKey="modal.systemErrorSaving">
          Due to a system error, we are currently unable to save your changes.
          Please try again later. If the issue continues, <SupportTicketLink />.
        </Trans>
      );
    }
    case UNABLE_TO_ADD_OBJECT: {
      return (
        <Trans
          i18nKey="modal.systemErrorSaving"
          aria-label="Due to a system error, we are currently unable to save your changes."
        >
          Due to a system error, we are currently unable to save your changes.
          Please try again later. If the issue continues, <SupportTicketLink />.
        </Trans>
      );
    }
    case Constants.ModalErrorType.UNABLE_TO_SAVE_SORT_ORDER_STALE_DATA: {
      return t('oneOrMoreChangesWhileReordering');
    }

    default: {
      return '';
    }
  }
};

const ModalError = () => {
  const { show, modalErrorType } = useSelector(getErrorModalState);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(hideModalError());
  };

  if (!show) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={handleModalClose}
      className="error-modal"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <>
            {getModalErrorTitle(modalErrorType, t)}
            <button
              className="ui-button button-no-appearance close-button"
              aria-label="Close topic modal"
              onClick={handleModalClose}
              type="button"
              data-testid="modal-error-close-button"
            >
              <Icon
                name="close"
                className="fill icon-orange-theme"
                width="18"
                height="18"
              />
            </button>
          </>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{getModalErrorBody(modalErrorType, t)}</Modal.Body>
    </Modal>
  );
};

export default ModalError;
